import React from 'react'
import PropTypes from 'prop-types'

import Text from '@hixme-ui/text'
import { Button, Label } from '@hixme-ui/forms'
import Container from '@hixme-ui/container'

import { TagsEditorContainer } from 'modules/tags/containers'
import PostEditor from './PostEditor/PostEditor'
import { NOTE_TYPE } from '../constants'

const PostNote = ({
  isProcessing,
  isPostingNote,
  handleSubmit,
  noteErrors,
  editorValue,
  setValue,
  onCancelNote,
  note,
}) => (
  <div>
    <Label
      div
      thin
      large
      style={{
        marginBottom: '10px',
      }}
    >
      {note.ItemType}
      <span> *</span>
    </Label>
    <PostEditor
      editorValue={editorValue}
      setValue={setValue}
      placeholder="Type your note here..."
    />
    <TagsEditorContainer Id={note.ItemPublicKey} ItemType={NOTE_TYPE} />
    <Container textCenter noPadding margin="0 20px 20px 0">
      <Text
        a
        light
        onClick={onCancelNote}
        style={{
          margin: '0 20px 20px 0',
        }}
      >
        Cancel
      </Text>
      <Button
        style={{
          margin: '0',
        }}
        disabled={isProcessing || noteErrors.length > 0}
        submitting={isPostingNote}
        submittingText="Adding..."
        onClick={handleSubmit}
      >
        Add note
      </Button>
      {noteErrors && (
        <Text
          style={{
            marginLeft: '0',
          }}
          span
          error
        >
          {' '}
          {noteErrors.join(' | ')}
        </Text>
      )}
    </Container>
  </div>
)

PostNote.displayName = 'PostNote'

PostNote.propTypes = {
  isProcessing: PropTypes.bool,
  isPostingNote: PropTypes.bool,
  handleSubmit: PropTypes.func,
  editorValue: PropTypes.object,
  setValue: PropTypes.func,
  noteErrors: PropTypes.array,
  onCancelNote: PropTypes.func,
  note: PropTypes.object.isRequired,
}

PostNote.defaultProps = {
  isProcessing: false,
  isPostingNote: false,
  handleSubmit: null,
  editorValue: null,
  setValue: null,
  noteErrors: [],
  constants: null,
  onCancelNote: null,
  tags: [],
}

export default PostNote
